<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 22H5a1 1 0 01-1-1V3a1 1 0 011-1h14a1 1 0 011 1v18a1 1 0 01-1 1zM6 20h12V4H6z"/><path d="M12.63 13a3.5 3.5 0 112.13-6.29.51.51 0 01.1.7.5.5 0 01-.7.1A2.54 2.54 0 0012.63 7a2.5 2.5 0 101.64 4.4.5.5 0 01.65.76 3.55 3.55 0 01-2.29.84z"/><path d="M12.46 9.12H8.91a.5.5 0 01-.5-.5.5.5 0 01.5-.5h3.55a.5.5 0 01.5.5.5.5 0 01-.5.5zM12.46 10.88H8.91a.5.5 0 01-.5-.5.5.5 0 01.5-.5h3.55a.5.5 0 01.5.5.5.5 0 01-.5.5zM15.5 18h-7a.5.5 0 010-1h7a.5.5 0 010 1zM15.5 15.5h-7a.5.5 0 010-1h7a.5.5 0 010 1z"/></svg>